import {
    CREATE_JOB_CATEGORY,
    CREATE_JOB_BENEFIT,
    CREATE_JOB_DESCRIPTION,
    CREATE_JOB_REQUIRMENT,
    CREATE_JOB_SUCCESS
} from '../actions/ActionType'

const INITIAL_STATE = {
    category: [],
    benefits: [],
    description: "",
    requirements: ""
}

export default (state = INITIAL_STATE, action) => {
    
    switch (action.type) {

        case CREATE_JOB_CATEGORY:
            
                const new_category = [...state.category]

                const index =  state.category.indexOf(action.payload)
    
                if(index  === -1){
                    new_category.push(action.payload)
                }else{
                    new_category.splice(index, 1)
                }

        return {...state, category: new_category}

        case CREATE_JOB_BENEFIT:
            const new_benefits = [...state.benefits]

            const index_benefit = state.benefits.indexOf(action.payload)
            if(index_benefit === -1) {
                new_benefits.push(action.payload)
            }else {
                new_benefits.slice(index_benefit, 1)
            }

        return {...state, benefits: new_benefits}
        
        case CREATE_JOB_DESCRIPTION:
        return {...state, description: action.payload}

        case CREATE_JOB_REQUIRMENT:
        return {...state, requirements: action.payload}

        case CREATE_JOB_SUCCESS:
        return {...state, category: [], benefits: [], requirements: "", description: ""}
        default:
            return state
    }
}